var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5851",
    "data-name": "Group 5851",
    transform: "translate(-2083 -1403)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(2083 1403)",
    fill: "#965ec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M394.511,487.48H381.123a3.552,3.552,0,0,0-3.547,3.548v13.119h-.346a1.43,1.43,0,0,0-1.43,1.43v8.671a1.43,1.43,0,0,0,1.43,1.43h.346v1.588a3.553,3.553,0,0,0,3.549,3.548h18.264a3.552,3.552,0,0,0,3.547-3.548V495.876Zm-13.5,24.174a1.323,1.323,0,0,0,1.06.48,1.209,1.209,0,0,0,.828-.306,1.786,1.786,0,0,0,.5-.961l1.17.371a2.629,2.629,0,0,1-.895,1.453,2.816,2.816,0,0,1-3.545-.338,3.106,3.106,0,0,1-.767-2.223,3.27,3.27,0,0,1,.771-2.318,2.644,2.644,0,0,1,2.027-.825,2.482,2.482,0,0,1,1.781.647,2.371,2.371,0,0,1,.612,1.1l-1.2.285a1.233,1.233,0,0,0-1.26-1,1.358,1.358,0,0,0-1.078.477,2.334,2.334,0,0,0-.414,1.544A2.509,2.509,0,0,0,381.011,511.654Zm18.384,6.987h-18.27a1.373,1.373,0,0,1-1.373-1.373v-1.59h17.028a1.43,1.43,0,0,0,1.43-1.43v-8.671a1.43,1.43,0,0,0-1.43-1.43H379.753V491.028a1.373,1.373,0,0,1,1.373-1.373l12.575-.014v4.648a2.46,2.46,0,0,0,2.461,2.461l4.553-.013.051,20.528A1.374,1.374,0,0,1,399.4,518.641Zm-10.571-7.675a.989.989,0,0,0-.433-.259c-.142-.049-.464-.135-.967-.261a3.271,3.271,0,0,1-1.361-.591,1.551,1.551,0,0,1-.551-1.2,1.534,1.534,0,0,1,.259-.854,1.624,1.624,0,0,1,.747-.606,2.993,2.993,0,0,1,1.176-.207,2.526,2.526,0,0,1,1.694.492,1.743,1.743,0,0,1,.6,1.317l-1.207.053a1.019,1.019,0,0,0-.332-.663,1.211,1.211,0,0,0-.764-.2,1.38,1.38,0,0,0-.824.216.435.435,0,0,0-.192.371.459.459,0,0,0,.18.362,3.171,3.171,0,0,0,1.109.4,5.864,5.864,0,0,1,1.3.43,1.678,1.678,0,0,1,.66.608,1.773,1.773,0,0,1,.239.952,1.755,1.755,0,0,1-.286.963,1.7,1.7,0,0,1-.807.666,3.371,3.371,0,0,1-1.3.218,2.591,2.591,0,0,1-1.741-.524,2.278,2.278,0,0,1-.726-1.527l1.174-.114a1.431,1.431,0,0,0,.43.868,1.3,1.3,0,0,0,.874.277,1.339,1.339,0,0,0,.879-.247.732.732,0,0,0,.3-.576A.544.544,0,0,0,388.825,510.967Zm1.735-3.879h1.309l1.513,4.423,1.464-4.423h1.28l-2.14,5.976H392.7Z",
    transform: "translate(1723.2 928.853)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCsv);
export default __webpack_public_path__ + "static/media/icon-csv.372f134a69f44c2eb919645180abfdf2.svg";
export { ForwardRef as ReactComponent };